import { TennisBallFilledIcon } from "@wags/ui/product-icons.tsx";
import { cn } from "@wags/ui/ui-utils";
import LetterA from "@/assets/icons/wags-wordmark-letter-a.svg";
import LetterG from "@/assets/icons/wags-wordmark-letter-g.svg";
import LetterS from "@/assets/icons/wags-wordmark-letter-s.svg";
import LetterW from "@/assets/icons/wags-wordmark-letter-w.svg";
import styles from "./footer-wordmark.module.css";
import { WORDMARK_PART } from "./parts";
import { mountFooterWordmark } from "./stage";

const LETTERS = [
    { key: "w", Glyph: LetterW },
    { key: "a", Glyph: LetterA },
    { key: "g", Glyph: LetterG },
    { key: "s", Glyph: LetterS },
] as const;

export function FooterWordmark() {
    return (
        <div
            ref={mountFooterWordmark}
            aria-hidden="true"
            className={cn(styles.stage, "mt-12 md:mt-18")}
        >
            <div data-part={WORDMARK_PART.balls} className={styles.balls}>
                <div
                    hidden
                    data-part={WORDMARK_PART.ballPrototype}
                    className={styles.ball}
                >
                    <TennisBallFilledIcon />
                </div>
            </div>
            <div className={styles.mark}>
                {LETTERS.map(({ key, Glyph }) => (
                    <div
                        key={key}
                        data-part={WORDMARK_PART.letter}
                        data-letter={key}
                        className={styles.letter}
                    >
                        <div className={styles.rise}>
                            <Glyph />
                            <Glyph className={styles.tint} />
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.fade} />
            <div data-part={WORDMARK_PART.hit} className={styles.hit} />
        </div>
    );
}
